import { useEffect, useState } from 'react'

export interface WidgetData<T> {
  data: T | null
  loading: boolean
  error: string
}

/**
 * F-072 — carica i dati di un widget da un'api esistente. `key` cambia quando cambiano i filtri del widget
 * (periodo, utente, team): ricarica. Un errore resta dentro il riquadro, non rompe la dashboard.
 */
export function useWidgetData<T>(load: () => Promise<T>, key: string): WidgetData<T> {
  const [state, setState] = useState<WidgetData<T>>({ data: null, loading: true, error: '' })
  useEffect(() => {
    let alive = true
    setState(prev => ({ ...prev, loading: true, error: '' }))
    load()
      .then(data => alive && setState({ data, loading: false, error: '' }))
      .catch(e => alive && setState({ data: null, loading: false, error: e instanceof Error ? e.message : 'Errore' }))
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key])
  return state
}
